function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { RecommendationComponent } from '../common/recommendation-component';
var RecommendationBundle = /*#__PURE__*/function (_RecommendationCompon) {
  function RecommendationBundle() {
    _classCallCheck(this, RecommendationBundle);
    return _callSuper(this, RecommendationBundle, arguments);
  }
  _inherits(RecommendationBundle, _RecommendationCompon);
  return _createClass(RecommendationBundle, [{
    key: "init",
    value: function init() {
      _get(_getPrototypeOf(RecommendationBundle.prototype), "init", this).call(this);
      this.handleBundleAddToCartForm();
      this.handleCheckBundleItem();
    }
  }, {
    key: "handleCheckBundleItem",
    value: function handleCheckBundleItem() {
      var _this = this;
      var elements = this.section.querySelectorAll('input[name="productsToAdd"]');
      elements.forEach(function (element) {
        element.addEventListener('change', function () {
          var currentInput = element;
          var checkedInputs = _this.section.querySelectorAll('input[type="checkbox"][name="productsToAdd"]:checked');
          _this.updateTotalProductCount(checkedInputs);
          _this.checkIfNoneChecked(currentInput, checkedInputs);
        });
      });
    }

    /**
     * Update the total product count and price in the bundle section
     * @param {NodeListOf<HTMLInputElement>} checkedInputs
     */
  }, {
    key: "updateTotalProductCount",
    value: function updateTotalProductCount(checkedInputs) {
      var _this2 = this;
      var mainProductElement = this.section.querySelector('.recommendation--bundle__items__product[data-position="1"]');
      var checkedProductElements = _toConsumableArray(checkedInputs.values()).map(function (input) {
        return _this2.section.querySelector(".recommendation--bundle__items__product[data-reflm=\"".concat(input.value, "\"]"));
      });
      var count = checkedInputs.length + 1;
      var newTotal = checkedProductElements.reduce(function (acc, element) {
        return acc + _this2.parsePrice(element.getAttribute('data-unit-amount'));
      }, this.parsePrice(mainProductElement.getAttribute('data-unit-amount')));
      var productCountElement = this.section.querySelector('.recommendation--bundle__total__product-count');
      if (productCountElement) {
        productCountElement.textContent = count;
      }
      var finalPriceElement = this.section.querySelector('.recommendation--bundle__total__price--final');
      if (finalPriceElement) {
        finalPriceElement.textContent = this.formatPrice(newTotal, '€');
      }
    }

    /**
     * Check if none of the products are checked and check the first
     * It is used to prevent the user to uncheck all the products
     * @param {HTMLInputElement} currentInput
     * @param {NodeListOf<HTMLInputElement>} checkedInputs
     */
  }, {
    key: "checkIfNoneChecked",
    value: function checkIfNoneChecked(currentInput, checkedInputs) {
      if (checkedInputs.length === 0) {
        var otherInput = this.section.querySelector('input[type="checkbox"][name="productsToAdd"]:not(:checked):not([value="' + currentInput.value + '"])');
        otherInput.checked = true;
        otherInput.dispatchEvent(new Event('change'));
      }
    }

    /**
     * Parse a price string to a number
     * @param {string} amount
     * @returns {number}
     */
  }, {
    key: "parsePrice",
    value: function parsePrice(amount) {
      return Number(amount.replace(',', '.'));
    }

    /**
     * Format the price. Ex: 12.00 €
     * @param {number} amount
     * @param {string} currency
     * @returns {string}
     */
  }, {
    key: "formatPrice",
    value: function formatPrice(amount, currency) {
      return amount.toFixed(2).replace(',', '.') + ' ' + currency;
    }
  }, {
    key: "handleBundleAddToCartForm",
    value: function handleBundleAddToCartForm() {
      var _this3 = this;
      this.section.querySelectorAll('form.js-ATC').forEach(function (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var data = JSON.parse(form.querySelector('input[name="productsToAdd"]').value);
          var listProducts = [data[0]];
          if (data.length === 2) {
            listProducts.push(data[1]);
          } else if (data.length === 3) {
            var checkedInputs = _this3.section.querySelectorAll('input[type="checkbox"][name="productsToAdd"]:checked');
            checkedInputs.forEach(function (input) {
              var productToAdd = data.find(function (product) {
                return product.reflm === input.value;
              });
              if (productToAdd) {
                listProducts.push(productToAdd);
              }
            });
          }
          _this3.cartUpdate({
            listProducts: listProducts
          });
        });
      });
    }
  }]);
}(RecommendationComponent);
_defineProperty(RecommendationBundle, "selector", '.recommendation--bundle');
_defineProperty(RecommendationBundle, "lazyLoadable", true);
export { RecommendationBundle as default };
lm.DOMReady(function () {
  return RecommendationBundle.setupOnceDomIsReady();
});